var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", { class: _vm.rootClass }, [
    !_vm.isSearch
      ? _c("td", { staticClass: "td_board", attrs: { scope: "row" } }, [
          _c(
            "div",
            { staticClass: "board_state" },
            [
              _vm.showsBoardName
                ? [
                    _vm.isCurrentArticle
                      ? _c("span", { staticClass: "ico_bbs ico_current" }, [
                          _vm._v("현재 보고있는 페이지"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("a", {
                      staticClass: "txt_name",
                      attrs: { href: _vm.boardUrl },
                      domProps: { innerHTML: _vm._s(_vm.boardName) },
                      on: { click: _vm.onBoardClick },
                    }),
                  ]
                : _c("div", { staticClass: "wrap_num" }, [
                    _vm.isCurrentArticle
                      ? _c("span", { staticClass: "ico_bbs ico_current" }, [
                          _vm._v("현재 보고있는 페이지"),
                        ])
                      : _vm._e(),
                    _vm._v("\n\t\t\t\t" + _vm._s(_vm.dataid) + "\n\t\t\t"),
                  ]),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("td", { staticClass: "td_title", attrs: { scope: "row" } }, [
      _c("span", { staticClass: "link_board" }, [
        _c("strong", { staticClass: "tit_board" }, [
          _vm.isReply
            ? _c(
                "span",
                { staticClass: "ico_bbs ico_reply", style: _vm.replyIconStyle },
                [_c("span", { staticClass: "sr_only" }, [_vm._v("답글")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "title_wrapper", style: _vm.replyTitleStyle },
            [
              _c("a", {
                staticClass: "txt_item",
                attrs: { href: _vm.url },
                domProps: { innerHTML: _vm._s(_vm.title) },
                on: { click: _vm.onTitleClick },
              }),
              _vm._v(" "),
              _vm.hasComment
                ? _c(
                    "a",
                    {
                      staticClass: "num_count_g",
                      attrs: { href: "javascript:" },
                      on: { click: _vm.openCommentPopup },
                    },
                    [
                      _c("span", { staticClass: "screen_out" }, [
                        _vm._v("댓글수"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "num_item",
                          class: _vm.commentCountClass,
                        },
                        [_vm._v(_vm._s(_vm.shrtcmtcnt))]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showsArticleIcons
                ? _c(
                    "article-icons",
                    _vm._b({}, "article-icons", _vm.iconsProps, false)
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.showsAuthor
      ? _c("td", { staticClass: "td_writer", attrs: { scope: "row" } }, [
          _c(
            "a",
            {
              staticClass: "txt_writer",
              attrs: { href: "javascript:" },
              on: { click: _vm._openLayer },
            },
            [_vm._v(_vm._s(_vm.nickname || "(익명)"))]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("td", { staticClass: "td_date", attrs: { scope: "row" } }, [
      _c("span", { staticClass: "tbl_txt_date" }, [
        _vm._v(_vm._s(_vm.regdtshow)),
      ]),
    ]),
    _vm._v(" "),
    !_vm.isSearch
      ? _c("td", { staticClass: "td_recommend", attrs: { scope: "row" } }, [
          _c("span", { staticClass: "tbl_txt_recommend" }, [
            _vm._v(_vm._s(_vm.recmdcnt)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("td", { staticClass: "td_look", attrs: { scope: "row" } }, [
      _c("span", { staticClass: "tbl_txt_look" }, [
        _vm._v(_vm._s(_vm.viewcount)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }